<template>
  <main class="main" role="main">
    <div class="app_down">
      <div class="app_down_inner">
        <div class="txt">
          <h1 class="aos-init">
            퍼스<span>&ensp;｜&ensp;</span>퍼블릭 스탠다드
          </h1>
          <div class="dot"></div>
          <h2>호갱의 기준을 제시하다.</h2>
          <div class="bg_phone">
            <img
              :src="require(`@/assets/front/images/img_phone_txt_bg.png`)"
              alt=""
            />
          </div>
        </div>
        <button class="btn_download go_down" @click.stop="appDownload()">
          <span>앱 다운받기</span>
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import { checkMobileOperatingSystem } from '@common/lib/common/utils';
export default {
  name: 'AppDownload',
  mounted() {},
  data() {
    return {};
  },
  methods: {
    appDownload() {
      if (checkMobileOperatingSystem() === 'iOS') {
        window.open(
          'https://apps.apple.com/us/app/%ED%8D%BC%EC%8A%A4-perce/id1569722707',
          '_blank',
        );
      } else {
        window.open(
          'https://play.google.com/store/apps/details?id=com.appg.perce_customer',
          '_blank',
        );
      }
    },
  },
};
</script>
